var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { buildInitialState } from '@components/Kendo/DateRangePickerReducer';
import { loadCacheFromLocalStorage } from '../../../../../helpers/localStorage';
import { ALL_COLUMNS, getColumnsCacheKey } from '../constants';
export const INITIAL_FILTERS = {
    values: Object.assign({ building: '', resolved: '' }, buildInitialState('dateOpened')),
    active: {
        building: true,
        dateOpened: true,
        resolved: true
    },
    operators: {
        building: 'eq',
        resolved: 'eq'
    }
};
export function getInitialFilters(buildingId) {
    if (buildingId) {
        return Object.assign(Object.assign({}, INITIAL_FILTERS), { values: Object.assign(Object.assign({}, INITIAL_FILTERS.values), { building: String(buildingId), resolved: '' // Clear resolved - show all on building page
             }) });
    }
    // Standalone page: filter to unresolved only
    return Object.assign(Object.assign({}, INITIAL_FILTERS), { values: Object.assign(Object.assign({}, INITIAL_FILTERS.values), { resolved: 'false' }) });
}
export function getInitialColumns(buildingId) {
    if (buildingId) {
        return ALL_COLUMNS.filter((column) => column !== 'building');
    }
    return ALL_COLUMNS.filter((column) => column !== 'resolved');
}
export function getInitialData({ cacheKey, buildingId }) {
    const cache = cacheKey ? loadCacheFromLocalStorage(cacheKey) || {} : {};
    const columnsCache = loadCacheFromLocalStorage(getColumnsCacheKey(buildingId)) || {};
    return {
        page: cache.page || { skip: 0, take: 25 },
        sort: cache.sort || [{ field: 'dateOpened', dir: 'desc' }],
        filters: cache.filters || getInitialFilters(buildingId),
        columns: columnsCache.columns || getInitialColumns(buildingId),
        data: [],
        totalCount: 0,
        loading: false
    };
}
export function saveCacheToLocalStorage(cacheKey, state, buildingId) {
    try {
        if (cacheKey) {
            const { columns } = state, gridState = __rest(state, ["columns"]);
            localStorage.setItem(cacheKey, JSON.stringify({ data: gridState }));
        }
        localStorage.setItem(getColumnsCacheKey(buildingId), JSON.stringify({ data: { columns: state.columns } }));
    }
    catch (error) {
        console.error('Failed to save cache to localStorage:', error);
    }
}
